import { isElement, toArray, forEach, isEqual, merge } from "lodash";
import Dropdown from "../../04-components/dropdown";
import {
    DROPDOWN_CLICKED
} from "../../02-const/event-names";
import {
    subscribe, unsubscribe
} from "../../01-helpers/event-manager";
import BreakpointUtil from "../../01-helpers/breakpoint-util";

/* ========================================================================= */

const
    selectors = {
        base: '.js-main-nav',
        items: `.js-dropdown`
    };

/* ========================================================================= */

function dropdownClicked(evt) {
    const dropdownId = evt.detail.dropdownId;
    forEach(this.itemInstances, (dropdown) => {
        if (isEqual(dropdownId, dropdown.id)) {
            dropdown.toggle();
        } else if (!BreakpointUtil.isPalm()) {
            dropdown.close();
        }
    })
}

function unbindEvents() {
    unsubscribe(DROPDOWN_CLICKED, dropdownClicked.bind(this));
}

/* ========================================================================= */

const mainNavItemDropdownConfig = {};

class MainNavItem extends Dropdown {
    constructor(itemElement, config = mainNavItemDropdownConfig) {
        super(itemElement, config);
    }
}

/* ========================================================================== */

const mainNavDefaultConfig = {};

export default class MainNav {
    constructor(baseElement, config = {}) {
        if (!isElement(baseElement)) {
            throw "Unable to create instance of MainNav, no baseElement has been provided";
        }

        const mergedConfig = merge({}, mainNavDefaultConfig, config);
        this._configure(baseElement, mergedConfig);
        this._setup();
    }

    /* ====================================================================== */

    _configure(baseElement, config) {
        const itemElements = baseElement.querySelectorAll(selectors.items);

        this.config = config;
        this.itemInstances = toArray(itemElements).map(itemElement => new MainNavItem(itemElement));
    }

    /* ====================================================================== */

    _setup() {
        this._setupSubscription();
        this._closeAllItems();
    }

    _setupSubscription() {
        subscribe(DROPDOWN_CLICKED, dropdownClicked.bind(this));
    }

    _closeAllItems() {
        this.itemInstances.forEach(instance => instance.close());
    }

    destroy() {
        forEach(this.itemInstances, dropdown => {
            dropdown.destroy();
        });
        unbindEvents.call(this);
    }
}
